export default __webpack_public_path__ + "static/media/0xd3c325848d7c6e29b574cb0789998b2ff901f17e.33a97f8f.svg";